import { useParams } from 'react-router-dom';
import { DEFAULT_LOCALE_CODE } from '@/consts/i18n';

// The URL segment is already resolved from the user's setting by RedirectToLocalised, and unlike
// react-i18next's i18n.language it doesn't lag behind navigation (see useTeamNavigationNew).
export const useUrlLocale = () => {
  const { locale = DEFAULT_LOCALE_CODE } = useParams();
  return locale;
};
